<mat-dialog-content>
  <lemon-dialog-header>Muokkaa profiilin osaa</lemon-dialog-header>

  <form novalidate>
    <mat-form-field>
      <mat-label>Nimi suomeksi</mat-label>
      <input type="text" #nimiFiInput [formField]="profiiliLomake.nimiFi" matInput />
      <!-- <mat-error *ngIf="profiiliNimiFi?.errors?.required && (profiiliNimiFi?.dirty || profiiliNimiFi?.touched)">
        Nimi puuttuu
      </mat-error> -->
      <mat-hint>Alkuperäinen: {{ tiliSignal().localisedName?.fi }}</mat-hint>
    </mat-form-field>
    <mat-form-field>
      <mat-label>Nimi englanniksi</mat-label>
      <input type="text" #nimiEnInput [formField]="profiiliLomake.nimiEn" matInput />
      <!-- <mat-error *ngIf="profiiliNimiEn?.errors?.required && (profiiliNimiEn?.dirty || profiiliNimiEn?.touched)">
        Nimi puuttuu
      </mat-error> -->
      <mat-hint>Alkuperäinen: {{ tiliSignal().localisedName?.en }}</mat-hint>
    </mat-form-field>
    <mat-checkbox [formField]="profiiliLomake.piilotettu">Piilotettu</mat-checkbox>
  </form>

  <!-- <form [formGroup]="form" novalidate>

    <div style="max-width: 250px; margin-bottom: 10px;">

      <mat-form-field>
        <mat-label>Vanhempi</mat-label>
        <mat-select formControlName="vanhempi">
          <mat-option [value]="null">Ei vanhempaa</mat-option>
          <mat-option *ngFor="let tili of tilitObservable | async" [value]="tili.numero">{{tili.numero}} {{tili.nimi}}</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field>
        <mat-label>Numero</mat-label>
        <input type="text" [name]="'aasd' + name" formControlName="numero" maxlength="4" minlength="1" decimalNumberField [numberOfDecimals]="0" matInput required />
        <mat-error *ngIf="numero?.errors?.maxlength || numero?.errors?.minlength && (numero?.dirty || numero?.touched)">
          Asiakaskohtaisen tilinumeron on oltava 1-4 merkkiä pitkä.
        </mat-error>
        <mat-error *ngIf="numero?.errors?.required && (numero?.dirty || numero?.touched)">
          Numero puuttuu
        </mat-error>
        <mat-error *ngIf="numero?.errors?.duplicate && (numero?.dirty || numero?.touched)">
          Tilinumero on jo käytössä.
        </mat-error>
      </mat-form-field>
      <mat-form-field>
        <mat-label>Nimi suomeksi</mat-label>
        <input type="text" [name]="'aasd' + name" formControlName="nimiFi" matInput required />
        <mat-error *ngIf="nimiFi?.errors?.required && (nimiFi?.dirty || nimiFi?.touched)">
          Nimi puuttuu
        </mat-error>
      </mat-form-field>
      <mat-form-field>
        <mat-label>Nimi englanniksi</mat-label>
        <input type="text" [name]="'aasda' + name" formControlName="nimiEn" matInput required />
        <mat-error *ngIf="nimiEn?.errors?.required && (nimiEn?.dirty || nimiEn?.touched)">
          Nimi puuttuu
        </mat-error>
      </mat-form-field>

      <mat-form-field>
        <mat-label>ALV-tyyppi</mat-label>
        <mat-select formControlName="alvtyyppi">
          <mat-option *ngFor="let lokalisoituAlvtyyppi of lokalisoidutAlvtyypit" [value]="lokalisoituAlvtyyppi.tyyppi">{{lokalisoituAlvtyyppi.nimi}}</mat-option>
        </mat-select>
        <mat-error *ngIf="alvtyyppi?.errors?.required && (alvtyyppi?.dirty || alvtyyppi?.touched)">
          Valinta puuttuu
        </mat-error>
      </mat-form-field>
      <mat-form-field>
        <mat-label>Oletus ALV-käsittely</mat-label>
        <mat-select formControlName="alv" [compareWith]="vertaaAlvMaarityksia">
          <mat-option *ngFor="let alv of alvt" [value]="alv">{{alv.nimi}}</mat-option>
        </mat-select>
        <mat-error *ngIf="alv?.errors?.required && (alv?.dirty || alv?.touched)">
          Oletus puuttuu
        </mat-error>
      </mat-form-field>
      <mat-checkbox formControlName="aktiivinen">Aktiivinen</mat-checkbox>
      <div style="margin-top:5px;">
        <mat-checkbox formControlName="reskontraActive">Reskontra päällä</mat-checkbox>
      </div>

    </div> 

  </form> -->
</mat-dialog-content>
<mat-dialog-actions style="padding-left: 3em; padding-right: 3em">
  <app-primary-button actionId="Tilikarttaprofiilit: Peruuta kirjanpitotilin muokkaus" mat-dialog-close>{{ 'yleiset.peruuta' | translate | async }}</app-primary-button>
  <app-secondary-button (click)="tallenna()" actionId="Tilikarttaprofiilit: Tallenna kirjanpitotilin muutokset" [actionContext]="[profiiliLomake().value()]">Tallenna</app-secondary-button>
</mat-dialog-actions>
